import { apiUrl } from "../../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createScheduledDelivery = createAsyncThunk(
  "scheduledDelivery/createScheduledDelivery",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    function formatStartLocal(dateString, hour = 10, minute = 0, second = 0) {
      const date = new Date(dateString);
      date.setHours(hour, minute, second, 0);
      return date.toISOString().slice(0, 19);
    }

    const byweekday = data.selectedWeekdays || [];

    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const deliveryData = {
      ds_active: data.ds_active,
      ds_driverID: data.driverID,
      ds_customer_id: data.customerID,
      ds_pickup_id: data.pickup_address,
      ds_dropoff_address: data.dropoff_address,
      schedule: {
        start_local: formatStartLocal(data.startDate, 10, 0, 0),
        timezone: userTimezone,
        mode: data.freq,
        custom: {
          freq: data.freq.toUpperCase(),
          interval: 1,
          byweekday,
          bymonthday: data.bymonthday ? [Number(data.bymonthday)] : [],
          end: { type: data.endsType, until_local: data.endDate },
          exdates_local: [],
        },
      },
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(deliveryData),
    };

    try {
      const response = await fetch(
        `${apiUrl}/create_scheduled_package`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Scheduled delivery creation failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const scheduledDeliverySlice = createSlice({
  name: "delivery",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    delivery: null,
  },
  reducers: {
    resetCreateScheduledDeliveryStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createScheduledDelivery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createScheduledDelivery.fulfilled, (state, action) => {
        state.delivery = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(createScheduledDelivery.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetCreateScheduledDeliveryStatus } =
  scheduledDeliverySlice.actions;
export default scheduledDeliverySlice.reducer;
